



























































































import {Vue, Component, Provide} from 'vue-property-decorator';
import frameList from '@/models/framelist';

import Paginition from '@/components/Paginition.vue';
import FilterMenu from '@/components/FilterMenu.vue';
import {Filter} from '@/utils/Filter';
import {NumberFilter} from '@/utils/NumberFilter';
import {Utils} from '@/utils/Utils';
import {API} from '@/services/api/api';
import {mapActions} from 'vuex';
@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  components: {
    Paginition,
    FilterMenu,
  },
})
export default class FrameList extends Vue {
  //list header titles
  header = [
    {
      value: 'shipname',
      name: 'Ship Name',
      headerType: 'text',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },
    {
      value: 'deckname',
      name: 'Deck Name',
      headerType: 'text',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },

    {
      value: 'zonename',
      name: 'Zone Name',
      headerType: 'text',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },

    {
      value: 'frameFrom',
      name: 'Frame From',
      headerType: 'number',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },
    {
      value: 'frameUpto',
      name: 'Frame Upto',
      headerType: 'number',
      asdcOrder: true,
      sortable: true,
      filter: true,
    },
    {
      value: 'edit',
      name: 'Edit',
      headerType: 'text',
      sortable: false,
      filter: false,
      bindClass: 'text-center',
    },
    {
      value: 'delete',
      name: 'Delete',
      headerType: 'text',
      sortable: false,
      filter: false,
      bindClass: 'text-center',
    },
  ];

  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point

  //sort variables
  curentSort = ''; //current sort on which header
  asdcOrder = true;

  //Store Variable
  showSuccessToast: any;
  showErrorToast: any;

  //Modal & Loader Variable
  isScreenLoading = false;
  modalVisible = false;
  loadingBtnStatus = false;
  modalConfimationMsg: any = null;
  modalTitle: any = null;

  frameId: any = null;
  deleteStatus: any = null;

  //emit sort data
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredFrameList);
    this.asdcOrder = sorted;
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }

  /**
   * @param emittedFilterParams filter params from FilterMenu component based upon selection
   * @returns returns filtered data based upon selection
   */
  filterOnNumber(emittedFilterParams: any) {
    let filteredData = Filter.filterOnNumberData(emittedFilterParams, this.frameList);

    this.filteredFrameList = filteredData;
    this.resetPagination();
  }

  //reset all filters and show current list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) {
      this.filteredFrameList = this.frameList;
      this.resetPagination();
    }
  }
  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  //Show delete model confirmation
  displayDeleteModal(recordId: number) {
    this.frameId = recordId;
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure want to delete ?';
    this.deleteStatus = true;
  }

  //call delete or activate/deactivate method based upon confirmation
  async deleteOrChangeStatus() {
    try {
      const response = await API.deleteFrameById(this.frameId);
      if (response) {
        this.showSuccessToast({msg: response.message});
        // this.getFramList();
        this.deleteFrame(this.frameId);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  filteredFrameList: frameList[] = [];

  frameList = this.filteredFrameList;

  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.frameList);
    this.filteredFrameList = filteredData;
    this.resetPagination();
  }

  //Go to Edit frame
  public editFrame(frameId: number) {
    this.$router.push({path: '/edit-frame/' + frameId});
  }

  //Delete frame
  public deleteFrame(frameId: number) {
    // this.filteredFrameList.forEach((framelist, index) => {
    //   if (framelist.id === frameId) {
    //     this.filteredFrameList.splice(index, 1);
    //   }
    // });
    this.filteredFrameList = this.filteredFrameList.filter((frame) => frame.id != this.frameId);
    this.frameList = this.frameList.filter((frame) => frame.id != this.frameId);
  }

  changeTabs() {
    this.$emit('switchTabFunction', 'createframe');
  }

  mounted() {
    this.getFramList();
  }

  //Get frames from APIs
  async getFramList() {
    this.isScreenLoading = true;
    try {
      const response = await API.fetchFrameList();

      if (response.data) {
        let frame = response.data;

        this.modifyArray(frame);
      } else {
        this.showErrorToast({msg: response.message});
        this.isScreenLoading = false;
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
      this.isScreenLoading = false;
    }
  }

  //Modeify data which is got from APIs and show them in tables
  modifyArray(frameData: any) {
    this.filteredFrameList = [];
    this.frameList = [];
    (this.filteredFrameList = frameData.map((frame) => {
      const framesArray = frame.frameofZones.map((frameOfZone) => ({
        ...frameOfZone,
        id: frameOfZone.id,

        shipname: frame.zone.drawing.ship.name,
        deckname: frame.zone.drawing.name,

        zonename: frame.zoneName,
      }));

      this.frameList = [...this.frameList, ...framesArray];
    })),
      (this.filteredFrameList = this.frameList);
    this.isScreenLoading = false;
  }
}
